import {
  FETCH_START,
  FETCH_ERROR,
  FETCH_SUCCESS,
  DB_LIST_INVITATIONS,
  DASHBOARD_CLIENT,
  DB_DASHBOARD_CONTENT,
} from "../../../constants/ActionTypes"


import setupAxiosInterceptors from "appRedux/actions/setupAxiosInterceptors";

import { surveyUserSignIn } from '../Auth'

import axios from 'util/ApiLimeSurvey'
import axiosDB from 'util/ApiDB'

export const DBListInvitation = () => {
  return (dispatch, getState) => {
    dispatch({ type: FETCH_START })
    const request = setupAxiosInterceptors(axiosDB, dispatch, getState);
    request.get('dashboard/invitation/list').then(({data}) => {
      
      const result = data.response.result;
      
      dispatch({type: DB_LIST_INVITATIONS, payload: {result: result}})
      
      dispatch({ type: FETCH_SUCCESS })
      
    }).catch(function (error) {
      dispatch({type: FETCH_ERROR, payload: error.message});
      console.log("Error****:", error.message);
    });
  }
}

export const ActionGetDashboardContent = () => {
  return (dispatch, getState) => {
    dispatch({ type: FETCH_START })

    const request = setupAxiosInterceptors(axiosDB, dispatch, getState);
    request.get('dashboard/content/get').then(({data}) => {
      
      const result = data.response.result;
      
      dispatch({type: DB_DASHBOARD_CONTENT, payload: {result: result}})
      
      dispatch({ type: FETCH_SUCCESS })
      
    }).catch(function (error) {
      dispatch({type: FETCH_ERROR, payload: error.message});
      console.log("Error****:", error.message);
    });
  }
}

export const ActionUpdateDashboardContent = (content) => {
  return (dispatch, getState) => {
    dispatch({ type: FETCH_START })
    const request = setupAxiosInterceptors(axiosDB, dispatch, getState);
   
    request.post('dashboard/content/update',{
      content: content
    }).then(({data}) => {
      dispatch(ActionGetDashboardContent());      
    }).catch(function (error) {
      dispatch({type: FETCH_ERROR, payload: error.message});
      console.log("Error****:", error.message);
    });
  }
}

export const ActionDashboardClient = (client_id) => {
  return (dispatch, getState) => {
    dispatch({type: DASHBOARD_CLIENT, payload: {client: client_id}})
  }
}
export const ResetDashboardClient = () => {
  return (dispatch, getState) => {
    dispatch({type: DASHBOARD_CLIENT, payload: {client: null}})
  }
}

export const ActionRemoteDeleteParticipant = (client_id, limesurvey_id, token_id) => {
  return (dispatch, getState) => {
    dispatch({ type: FETCH_START })

    const { limesurvey_session_key } = getState().authSurvey
    const requestDB = setupAxiosInterceptors(axiosDB, dispatch, getState);

    //delete from Remote Limesurvey
    axios.post('admin/remotecontrol', {
      method: 'delete_participants',
      params: [
        limesurvey_session_key,
        limesurvey_id,
        [
          parseInt(token_id)
        ]
      ],
      id: 1
    }).then(({ data }) => {
      if (data.result.status && data.result.status.toLowerCase() === 'invalid session key') {
        //dispatch({type: FETCH_ERROR, payload: "Refreshing session, please try again."})
        localStorage.removeItem("limesurvey_session_key");
        dispatch(surveyUserSignIn()).then(() => {
          dispatch(ActionRemoteDeleteParticipant(client_id, limesurvey_id, token_id))
        })
      } else {

        requestDB.post('survey/token/delete', {
          survey: limesurvey_id,
          client: client_id,
          token_id: token_id
        }).then(({ data }) => {
          // token deleted from DB
          dispatch(DBListInvitation())
        }).catch(function (error) {
          dispatch({ type: FETCH_ERROR, payload: error.message });
          console.log("Error****:", error.message);
        });
      }
    }).catch(function (error) {
      dispatch({ type: FETCH_ERROR, payload: error.message });
      console.log("Error****:", error.message);
    });


  }
}
